<template>
  <div class="index">
    <div class="index-con" v-for="(item, index) in jbList" :key="index">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>IDAST</span> <b>→</b>
        <span>副院士</span><b>→</b> <span>{{ item.news_title }}</span>
      </div>
      <div class="title">{{ item.news_title }}</div>
      <div class="box">
        <div class="abouts">
          <div> <img :src="item.image_url"> </div>
          <div class="abouttext">

            <div>头衔: {{ item.writer }}</div>
            <div>机构: {{ item.school }}</div>
            <div>国家: {{ item.source }}</div>
          </div>
        </div>
        <div class="text">
          <div v-html="item.news_content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jbList: [],
      id: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getJbList();
  },
  methods: {
    getJbList() {
      this.$http.jb_list
        ({
          news_id: this.id,
        })
        .then((res) => {
          this.jbList = res.data;
        });
    }
  }

};
</script>

<style lang="less" scoped>
.abouts {
  display: flex;
  flex-direction: row;

  img {
    width: 150px;
    height: 200px;
  }
}

.abouttext {
  margin-left: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #666666;
  line-height: 70px;

}

.text {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  margin-top: 20px;
}

.title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .small-title {
    margin: 25px 0;
    font-weight: 600;
  }

  .card {
    padding: 25px 15px;
    box-sizing: border-box;
    position: relative;
    font-weight: 700;
    line-height: 1.9;
    background-color: hsla(0, 0%, 50.2%, 0.05);

    .card-title {
      color: #5b965a;
      margin-bottom: 20px;
    }

    img {
      position: absolute;
      bottom: 30px;
      right: 35px;
      width: 35%;
      height: auto;
    }

    .right {
      position: absolute;
      bottom: 30px;
      right: 35px;
      width: 35%;
      height: auto;
    }
  }

  .box {
    padding: 0 100px;
    box-sizing: border-box;
  }

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .text-green {
    color: #5b965a;
  }

  .title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 250px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 600px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/committeesDetail2.vue